import React, { useState, useEffect, useRef } from "react";
import { CiStopwatch } from "react-icons/ci";
import { IoMdClose } from "react-icons/io";
import { SlArrowDown } from "react-icons/sl";
import { FaMinus } from "react-icons/fa6";
import { FaPlus } from "react-icons/fa6";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { addToCart, removeFromCart } from "../../utils/cartUtils";
import Login from "../Layout/Login/Login";

export default function ProductList1({ }) {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [quantities, setQuantities] = useState({});
  const [cartItems, setCartItems] = useState({}); // Added to store cart_id and product_id
  const [selectedCategoryStyle, setSelectedCategoryStyle] = useState({});
  const [themeColor, setThemeColor] = useState("#708090");
  const [productsPerRow, setProductsPerRow] = useState(5);
  const [categoryCardNo, setCategoryCardNo] = useState(2);
  const [categoryTextPosition, setcategoryTextPosition] = useState("Right");
  const [imageIndexes, setImageIndexes] = useState({});
  const { maincategory_auto_id } = useParams();
  const [productImageAnimation, setProductImageAnimation] = useState(
    "On Hover Scrolling "
  );
  const [hoveredProductId, setHoveredProductId] = useState(null);
  const fetched = useRef(false);
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  const [vibratingButtons, setVibratingButtons] = useState({});
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const openLoginModal = () => setIsLoginModalOpen(true);
  const closeLoginModal = () => setIsLoginModalOpen(false);

  const [sortOption, setSortOption] = useState("Select");

  const options = [
    { value: "price_low_high", label: "Price (Low to High)" },
    { value: "price_high_low", label: "Price (High to Low)" },
    { value: "discount_high_low", label: "Discount (High to Low)" },
  ];

  useEffect(() => {
    if (products.length === 0) return; // Skip if no products

    const sortedProducts = [...products]; // Create a copy to avoid mutating state

    switch (sortOption) {
      case "price_low_high":
        sortedProducts.sort((a, b) => a.price[0] - b.price[0]);
        break;

      case "price_high_low":
        sortedProducts.sort((a, b) => b.price[0] - a.price[0]);
        break;

      case "discount_high_low":
        sortedProducts.sort((a, b) => (b.discount || 0) - (a.discount || 0));
        break;

      default:
        break;
    }

    setProducts(sortedProducts); // Update state with sorted products
  }, [sortOption, products.length]); // Depend on sortOption and products.length

  useEffect(() => {
    const fetchSubCategories = async () => {
      if (fetched.current) return;
      fetched.current = true;

      try {
        const response = await axios.post(
          "https://gruzen.in/GrobizEcommerceAppBuilder/api/get_sub_category_list",
          {
            main_category_auto_id: maincategory_auto_id,
            admin_auto_id: sessionStorage.getItem("admin_auto_id"),
            app_type_id: sessionStorage.getItem("app_type_id"),
          }
        );

        if (response.data.status === 1) {
          const newCategories = response.data.getmain_subcategorylist.map(
            (item) => ({
              id: item._id,
              name: item.sub_category_name,
              image: `https://grobizapp-n.s3.ap-south-1.amazonaws.com/subcategories/${item.subcategory_image_app}`,
            })
          );
          setCategories(newCategories);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (maincategory_auto_id) {
      fetchSubCategories();
    }
  }, [maincategory_auto_id]);

  useEffect(() => {
    if (categories.length > 0) {
      setSelectedCategory(categories[0].name);
      fetchProducts(categories[0].id);
    }
  }, [categories]);

  const fetchProducts = async (subCatId) => {
    try {
      setProducts([]);
      const adminAutoId = sessionStorage.getItem("admin_auto_id");
      const appTypeId = sessionStorage.getItem("app_type_id");
      const accessToken = sessionStorage.getItem("accessToken");

      const formData = new FormData();
      formData.append("customer_auto_id", accessToken || adminAutoId);
      formData.append("admin_auto_id", adminAutoId);
      formData.append("limit", "6");
      formData.append("page_number", "1");
      formData.append("sub_cat_id", subCatId);
      formData.append("app_type_id", appTypeId);

      const response = await axios.post(
        "https://gruzen.in/GrobizEcommerceAppBuilder/api/get_Admin_Subcategory_Product",
        formData
      );

      if (response.data.status === 1) {
        const newProducts =
          response.data.get_admin_subcategory_product_lists.map((item) => {
            let price = [];
            if (item.size.length > 0 && item.get_price_lists.length > 0) {
              price = item.get_price_lists.map((p) =>
                parseFloat(p.final_size_price || 0)
              );
            } else {
              price = [parseFloat(item.final_product_price || 0)];
            }

            return {
              id: item.product_auto_id,
              name: item.product_name,
              price: price,
              size:
                item.size.length > 0
                  ? item.size.map((s) => ({
                    name: s.size_name,
                    id: s.size_auto_id,
                  }))
                  : [{ name: "Default Size", id: null }],
              images: item.product_images.map(
                (img) =>
                  `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${img.product_image}`
              ),
              time: item.time,
              timeUnit: item.time_unit,
              moq: item.moq || 1, // Added MOQ for cart operations
              discount: item.offer_percentage ? parseFloat(item.offer_percentage) : 0,
            };
          });

        setProducts(newProducts);
      }
      else {
        setProducts([]);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
      setProducts([]);
    }
  };

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setSelectedCategoryStyle(parsedStyle.hover_effect || "");
      setThemeColor(parsedStyle.web_theme_colour);
      setProductsPerRow(parseInt(parsedStyle.product_per_row));
      setCategoryCardNo(parseInt(parsedStyle.categorycard_no));
      setcategoryTextPosition(parsedStyle.category_text_position);
      setProductImageAnimation(parsedStyle.product_image_animation);
    }
  }, []);

  const updateCartQuantity = async (cartProductAutoId, newQuantity) => {
    try {
      await axios.post(
        "https://gruzen.in/GrobizEcommerceAppBuilder/api/edit_cart_product",
        {
          cart_product_auto_id: cartProductAutoId,
          cart_quantity: newQuantity,
        }
      );
    } catch (error) {
      console.error("Error updating cart:", error);
    }
  };

  const triggerVibrateAndLogin = (key) => {
    setVibratingButtons((prev) => ({ ...prev, [key]: true }));
    setTimeout(() => {
      setVibratingButtons((prev) => ({ ...prev, [key]: false }));
      openLoginModal();
    }, 500);
  };

  const handleQuantityChange = async (productId, sizeId, change) => {
    const key = `${productId}-${sizeId}`;
    const product = products.find((p) => p.id === productId);
    const currentQuantity = quantities[key] || 0;
    const newQuantity = Math.max(currentQuantity + change, 0);

    if (!sessionStorage.getItem("accessToken")) {
      triggerVibrateAndLogin(key);
      return;
    }

    if (newQuantity === 0) {
      // Remove from cart
      setQuantities((prev) => {
        const updated = { ...prev };
        delete updated[key];
        return updated;
      });

      setCartItems((prev) => {
        const updated = { ...prev };
        delete updated[key];
        return updated;
      });

      const productIdToRemove = cartItems[key]?.product_id;
      if (productIdToRemove) {
        try {
          await removeFromCart(productIdToRemove);
        } catch (error) {
          console.error("Error removing from cart:", error);
        }
      }
    } else if (change > 0 && currentQuantity === 0) {
      // Add to cart
      const payload = {
        product_auto_id: productId,
        added_by_id:
          sessionStorage.getItem("accessToken") ||
          sessionStorage.getItem("admin_auto_id"),
        cart_quantity: product?.moq || 1,
        size_id: sizeId !== null ? sizeId : undefined, // Include size_id if applicable
      };

      try {
        const response = await addToCart(payload);
        const cartItemId = response?.data?._id;
        const productAutoId = response?.data?.product_auto_id;

        if (cartItemId && productAutoId) {
          setQuantities((prev) => ({ ...prev, [key]: newQuantity }));
          setCartItems((prev) => ({
            ...prev,
            [key]: {
              cart_id: cartItemId,
              product_id: productAutoId,
            },
          }));
        }
      } catch (error) {
        console.error("Add to cart failed", error);
        setQuantities((prev) => {
          const updated = { ...prev };
          delete updated[key];
          return updated;
        });
      }
    } else {
      // Update quantity
      setQuantities((prev) => ({ ...prev, [key]: newQuantity }));
      const cartId = cartItems[key]?.cart_id;
      if (cartId) {
        updateCartQuantity(cartId, newQuantity);
      }
    }
  };

  const handleQuantityChangeModal = async (sizeId, change) => {
    if (selectedProduct) {
      const key = `${selectedProduct.id}-${sizeId}`;
      const currentQuantity = quantities[key] || 0;
      const newQuantity = Math.max(currentQuantity + change, 0);


      if (!sessionStorage.getItem("accessToken")) {
        triggerVibrateAndLogin(key);
        return;
      }

      if (newQuantity === 0) {
        // Remove from cart
        setQuantities((prev) => {
          const updated = { ...prev };
          delete updated[key];
          return updated;
        });

        setCartItems((prev) => {
          const updated = { ...prev };
          delete updated[key];
          return updated;
        });

        const productIdToRemove = cartItems[key]?.product_id;
        if (productIdToRemove) {
          try {
            await removeFromCart(productIdToRemove);
          } catch (error) {
            console.error("Error removing from cart:", error);
          }
        }
      } else if (change > 0 && currentQuantity === 0) {
        // Add to cart
        const payload = {
          product_auto_id: selectedProduct.id,
          added_by_id:
            sessionStorage.getItem("accessToken") ||
            sessionStorage.getItem("admin_auto_id"),
          cart_quantity: selectedProduct?.moq || 1,
          size_id: sizeId !== null ? sizeId : undefined,
        };

        try {
          const response = await addToCart(payload);
          const cartItemId = response?.data?._id;
          const productAutoId = response?.data?.product_auto_id;

          if (cartItemId && productAutoId) {
            setQuantities((prev) => ({ ...prev, [key]: newQuantity }));
            setCartItems((prev) => ({
              ...prev,
              [key]: {
                cart_id: cartItemId,
                product_id: productAutoId,
              },
            }));
          }
        } catch (error) {
          console.error("Add to cart failed", error);
          setQuantities((prev) => {
            const updated = { ...prev };
            delete updated[key];
            return updated;
          });
        }
      } else {
        // Update quantity
        setQuantities((prev) => ({ ...prev, [key]: newQuantity }));
        const cartId = cartItems[key]?.cart_id;
        if (cartId) {
          updateCartQuantity(cartId, newQuantity);
        }
      }
    }
  };

  const openModal = (product) => {

    setSelectedProduct(product);
    setIsModalOpen(true);
  };

  useEffect(() => {
    if (productImageAnimation === "Auto Scrolling") {
      const interval = setInterval(() => {
        setImageIndexes((prevIndexes) => {
          const newIndexes = { ...prevIndexes };
          products.forEach((product) => {
            if (product.images && product.images.length > 0) {
              newIndexes[product.id] = (prevIndexes[product.id] || 0) + 1;
              if (newIndexes[product.id] >= product.images.length) {
                newIndexes[product.id] = 0;
              }
            }
          });
          return newIndexes;
        });
      }, 3000);

      return () => clearInterval(interval);
    }
  }, [productImageAnimation, products]);

  useEffect(() => {
    let interval;
    if (productImageAnimation === "On Hover Scrolling" && hoveredProductId) {
      interval = setInterval(() => {
        setImageIndexes((prevIndexes) => {
          const product = products.find((p) => p.id === hoveredProductId);
          if (product && product.images && product.images.length > 0) {
            const currentIdx = prevIndexes[hoveredProductId] || 0;
            const nextIdx = (currentIdx + 1) % product.images.length;
            return {
              ...prevIndexes,
              [hoveredProductId]: nextIdx,
            };
          }
          return prevIndexes;
        });
      }, 1000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [hoveredProductId, productImageAnimation]);

  const handleLeftClick = (productId) => {
    setImageIndexes((prevIndexes) => {
      const product = products.find((p) => p.id === productId);
      if (product && product.images && product.images.length > 0) {
        const currentIdx = prevIndexes[productId] || 0;
        const newIdx =
          currentIdx - 1 < 0 ? product.images.length - 1 : currentIdx - 1;
        return { ...prevIndexes, [productId]: newIdx };
      }
      return prevIndexes;
    });
  };

  const handleRightClick = (productId) => {
    setImageIndexes((prevIndexes) => {
      const product = products.find((p) => p.id === productId);
      if (product && product.images && product.images.length > 0) {
        const currentIdx = prevIndexes[productId] || 0;
        const newIdx = (currentIdx + 1) % product.images.length;
        return { ...prevIndexes, [productId]: newIdx };
      }
      return prevIndexes;
    });
  };

  return (
    <div>
      <style>
        {`
          @keyframes vibrate {
            0% { transform: translate(0); }
            20% { transform: translate(-2px, 2px); }
            40% { transform: translate(-2px, -2px); }
            60% { transform: translate(2px, 2px); }
            80% { transform: translate(2px, -2px); }
            100% { transform: translate(0); }
          }
          .vibrate {
            animation: vibrate 0.5s linear;
          }
        `}
      </style>
      <div className="flex flex-col bg-white">
        <div className="flex">
          {/* Sidebar */}
          <div
            className="w-1/4 max-h-screen overflow-y-auto no-scrollbar md:w-1/6"
            style={{ scrollbarWidth: "none" }}
          >
            {categoryCardNo === 0 && (
              <div className="w-full h-full bg-white border-r">
                <ul className="px-0 mt-3">
                  {categories.map((category) => (
                    <li
                      key={category.name}
                      className={`p-2 md:p-3 flex items-center gap-2 cursor-pointer border-b ${selectedCategoryStyle === "underline"
                          ? "hover:underline"
                          : ""
                        }`}
                      style={{
                        backgroundColor:
                          selectedCategoryStyle === "background_colour" &&
                            selectedCategory === category.name
                            ? themeColor + "33"
                            : "transparent",
                        borderLeft:
                          selectedCategoryStyle === "background_colour" &&
                            selectedCategory === category.name
                            ? `4px solid ${themeColor}`
                            : "4px solid transparent",
                      }}
                      onClick={() => {
                        setSelectedCategory(category.name);
                        fetchProducts(category.id);
                      }}
                      onMouseEnter={(e) => {
                        if (selectedCategoryStyle === "background_colour") {
                          e.currentTarget.style.backgroundColor =
                            themeColor + "33";
                          e.currentTarget.style.borderLeft = `4px solid ${themeColor}`;
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (
                          selectedCategoryStyle === "background_colour" &&
                          selectedCategory !== category.name
                        ) {
                          e.currentTarget.style.backgroundColor = "transparent";
                          e.currentTarget.style.borderLeft =
                            "4px solid transparent";
                        }
                      }}
                    >
                      <span
                        className={`text-xs md:text-sm truncate ${selectedCategory === category.name &&
                            selectedCategoryStyle === "underline"
                            ? "underline"
                            : ""
                          }`}
                      >
                        {category.name}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {categoryCardNo === 1 && (
              <div className="w-full h-full bg-white border-r">
                <ul className="px-0 mt-3">
                  {categories.map((category) => (
                    <li
                      key={category.name}
                      className="flex items-center justify-center gap-2 p-2 border-b cursor-pointer md:p-3"
                      style={{
                        backgroundColor:
                          selectedCategoryStyle === "background_colour" &&
                            selectedCategory === category.name
                            ? themeColor + "33"
                            : "transparent",
                        borderLeft:
                          selectedCategoryStyle === "background_colour"
                            ? `4px solid ${selectedCategory === category.name
                              ? themeColor
                              : "transparent"
                            }`
                            : "none",
                      }}
                      onClick={() => {
                        setSelectedCategory(category.name);
                        fetchProducts(category.id);
                      }}
                      onMouseEnter={(e) => {
                        if (selectedCategoryStyle === "background_colour") {
                          e.currentTarget.style.backgroundColor =
                            themeColor + "33";
                          e.currentTarget.style.borderLeft = `4px solid ${themeColor}`;
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (
                          selectedCategoryStyle === "background_colour" &&
                          selectedCategory !== category.name
                        ) {
                          e.currentTarget.style.backgroundColor = "transparent";
                          e.currentTarget.style.borderLeft = "none";
                        }
                      }}
                    >
                      <img
                        src={category.image}
                        alt={category.name}
                        className="w-8 h-10 rounded-lg md:w-16 md:h-16"
                      />
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {categoryCardNo === 2 && (
              <div className="w-full h-full bg-white border-r">
                <ul className="px-0 mt-3">
                  {categories.map((category) => (
                    <li
                      key={category.name}
                      className={`p-2 md:p-3 flex ${categoryTextPosition === "Top" ||
                          categoryTextPosition === "Bottom"
                          ? "flex-col items-center"
                          : categoryTextPosition === "Left"
                            ? "flex-row-reverse items-center justify-start"
                            : "flex-row items-center"
                        } gap-2 cursor-pointer border-b ${selectedCategoryStyle === "underline"
                          ? "hover:underline"
                          : ""
                        }`}
                      style={{
                        backgroundColor:
                          selectedCategoryStyle === "background_colour" &&
                            selectedCategory === category.name
                            ? themeColor + "33"
                            : "transparent",
                        borderLeft:
                          selectedCategoryStyle === "background_colour"
                            ? `4px solid ${selectedCategory === category.name
                              ? themeColor
                              : "transparent"
                            }`
                            : "none",
                      }}
                      onClick={() => {
                        setSelectedCategory(category.name);
                        fetchProducts(category.id);
                      }}
                      onMouseEnter={(e) => {
                        if (selectedCategoryStyle === "background_colour") {
                          e.currentTarget.style.backgroundColor =
                            themeColor + "33";
                          e.currentTarget.style.borderLeft = `4px solid ${themeColor}`;
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (
                          selectedCategoryStyle === "background_colour" &&
                          selectedCategory !== category.name
                        ) {
                          e.currentTarget.style.backgroundColor = "transparent";
                          e.currentTarget.style.borderLeft = "none";
                        }
                      }}
                    >
                      {categoryTextPosition === "Top" && (
                        <span
                          className={`text-xs md:text-sm truncate ${selectedCategory === category.name &&
                              selectedCategoryStyle === "underline"
                              ? "underline"
                              : ""
                            }`}
                        >
                          {category.name}
                        </span>
                      )}
                      <img
                        src={category.image}
                        alt={category.name}
                        className="w-8 h-10 rounded-lg md:w-10 md:h-12"
                      />
                      {(categoryTextPosition === "Right" ||
                        categoryTextPosition === "Left") && (
                          <span
                            className={`text-xs md:text-sm truncate ${selectedCategory === category.name &&
                                selectedCategoryStyle === "underline"
                                ? "underline"
                                : ""
                              }`}
                          >
                            {category.name}
                          </span>
                        )}
                      {categoryTextPosition === "Bottom" && (
                        <span
                          className={`text-xs md:text-sm truncate ${selectedCategory === category.name &&
                              selectedCategoryStyle === "underline"
                              ? "underline"
                              : ""
                            }`}
                        >
                          {category.name}
                        </span>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>

          {/* Products Section */}
          <div className="flex-1 pt-0 bg-slate-100">
            <div className="flex items-center justify-between p-2 mb-0 bg-white">
              <h2 className="text-sm font-semibold md:text-xl">
                Buy {selectedCategory} Online
              </h2>
              <div className="items-center hidden mr-10 text-sm md:flex">
                <span className="mr-2 text-gray-500">Sort By</span>
                <select
                  className="w-40 px-1 py-1 border border-gray-300 rounded-md"
                  value={sortOption}
                  onChange={(e) => setSortOption(e.target.value)}
                  style={{ color:themeColor }}
                >
                  {options.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div
              className="max-h-screen overflow-y-auto no-scrollbar"
              style={{ scrollbarWidth: "none" }}
            >
              {/* 5 products per row */}
              {productsPerRow === 5 && (
                <div className="grid grid-cols-2 gap-2 md:grid-cols-5 md:p-2">
                  {products.map((product) => (
                    <div
                      key={product.name}
                      className="p-2 text-center bg-white border rounded-lg shadow-md md:p-3 h-72 md:h-80"
                    >
                      <div className="relative">
                        {(productImageAnimation === "Auto Scrolling" ||
                          productImageAnimation === "On Hover Scrolling" ||
                          productImageAnimation === "On Arrow Click") && (
                            <img
                              src={
                                product.images
                                  ? product.images[imageIndexes[product.id] || 0]
                                  : product.image
                              }
                              alt={product.name}
                              className="object-contain w-full transition-opacity duration-500 max-h-36"
                              onMouseEnter={() => setHoveredProductId(product.id)}
                              onMouseLeave={() => setHoveredProductId(null)}
                              onClick={() =>
                                navigate(`/product-detail/${product.id}`)
                              }
                            />
                          )}
                        {productImageAnimation === "On Arrow Click" && (
                          <>
                            <button
                              onClick={() => handleLeftClick(product.id)}
                              className="absolute left-0 transform -translate-y-1/2 top-1/2"
                            >
                              <BsChevronLeft className="text-gray-700" />
                            </button>
                            <button
                              onClick={() => handleRightClick(product.id)}
                              className="absolute right-0 transform -translate-y-1/2 top-1/2"
                            >
                              <BsChevronRight className="text-gray-700" />
                            </button>
                          </>
                        )}
                      </div>
                      <div className="flex items-center justify-start gap-1 px-1 text-xs font-semibold text-gray-900 bg-slate-50 max-w-16">
                        <CiStopwatch /> {product.time} {product.timeUnit}
                      </div>
                      <h3 className="mt-2 text-sm font-semibold text-left truncate">
                        {product.name}
                      </h3>
                      {product.size.length > 0 &&
                        product.size[0].id !== null && (
                          <div
                            className="flex items-center justify-between w-full h-10 px-3 border border-gray-300 rounded-md cursor-pointer"
                            onClick={() => openModal(product)}
                          >
                            <span className="text-black text-md">
                              {product.size[0].name}
                            </span>
                            <span className="text-gray-500">
                              <SlArrowDown />
                            </span>
                          </div>
                        )}
                      <div className="flex items-center justify-between">
                        <p className="pt-3 font-bold">₹{product.price[0]}</p>
                        {quantities[`${product.id}-${product.size[0].id}`] ? (
                          <div
                            className="flex items-center gap-2 px-2 py-1 text-white border rounded"
                            style={{ backgroundColor: themeColor }}
                          >
                            <button
                              onClick={() =>
                                handleQuantityChange(
                                  product.id,
                                  product.size[0].id,
                                  -1
                                )
                              }
                              className="px-1 py-1 text-sm font-semibold text-white rounded"
                              style={{ backgroundColor: themeColor }}
                            >
                              <FaMinus />
                            </button>
                            <input
                              type="number"
                              min="0"
                              value={
                                quantities[
                                `${product.id}-${product.size[0].id}`
                                ] ?? ""
                              }
                              onChange={async (e) => {
                                const rawValue = e.target.value;
                                const key = `${product.id}-${product.size[0].id}`;

                                if (rawValue === "") {
                                  setQuantities((prev) => ({
                                    ...prev,
                                    [key]: "",
                                  }));
                                  return;
                                }

                                const value = parseInt(rawValue);
                                if (!isNaN(value)) {
                                  setQuantities((prev) => ({
                                    ...prev,
                                    [key]: value,
                                  }));

                                  const cartItem = cartItems[key];
                                  const cartId = cartItem?.cart_id;
                                  const productId = cartItem?.product_id;

                                  if (value === 0) {
                                    setQuantities((prev) => {
                                      const updated = { ...prev };
                                      delete updated[key];
                                      return updated;
                                    });

                                    setCartItems((prev) => {
                                      const updated = { ...prev };
                                      delete updated[key];
                                      return updated;
                                    });

                                    if (productId) {
                                      try {
                                        await removeFromCart(productId);
                                      } catch (error) {
                                        console.error(
                                          "Error removing from cart:",
                                          error
                                        );
                                      }
                                    }
                                  } else if (cartId) {
                                    updateCartQuantity(cartId, value);
                                  }
                                }
                              }}
                              onBlur={() => {
                                const key = `${product.id}-${product.size[0].id}`;
                                if (quantities[key] === "") {
                                  setQuantities((prev) => ({
                                    ...prev,
                                    [key]: 1,
                                  }));
                                  const cartId = cartItems[key]?.cart_id;
                                  if (cartId) updateCartQuantity(cartId, 1);
                                }
                              }}
                              className="w-10 h-6 font-semibold text-center bg-gray-300 rounded"
                            />
                            <button
                              onClick={() =>
                                handleQuantityChange(
                                  product.id,
                                  product.size[0].id,
                                  1
                                )
                              }
                              className="px-1 py-1 text-sm font-semibold text-white rounded"
                              style={{ backgroundColor: themeColor }}
                            >
                              <FaPlus />
                            </button>
                          </div>
                        ) : (
                          <button
                            onClick={() => {
                              const key = `${product.id}-${product.size[0].id}`;
                              handleQuantityChange(product.id, product.size[0].id, 1);
                            }}
                            className={`border-1 py-2 px-4 rounded text-sm font-semibold bg-slate-50 ${vibratingButtons[`${product.id}-${product.size[0].id}`]
                                ? "vibrate"
                                : ""
                              }`}
                            style={{
                              color: themeColor,
                              border: `1px solid ${themeColor}`,
                            }}
                          >
                            ADD
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* 4 products per row */}
              {productsPerRow === 4 && (
                <div className="grid grid-cols-2 gap-2 md:grid-cols-4 md:p-2">
                  {products.map((product) => (
                    <div
                      key={product.name}
                      className="p-2 text-center bg-white border rounded-lg shadow-md md:p-3 h-72 md:h-80"
                    >
                      <div className="relative">
                        {(productImageAnimation === "Auto Scrolling" ||
                          productImageAnimation === "On Hover Scrolling" ||
                          productImageAnimation === "On Arrow Click") && (
                            <img
                              src={
                                product.images
                                  ? product.images[imageIndexes[product.id] || 0]
                                  : product.image
                              }
                              alt={product.name}
                              className="object-contain w-full transition-opacity duration-500 max-h-36"
                              onMouseEnter={() => setHoveredProductId(product.id)}
                              onMouseLeave={() => setHoveredProductId(null)}
                              onClick={() =>
                                navigate(`/product-detail/${product.id}`)
                              }
                            />
                          )}
                        {productImageAnimation === "On Arrow Click" && (
                          <>
                            <button
                              onClick={() => handleLeftClick(product.id)}
                              className="absolute left-0 transform -translate-y-1/2 top-1/2"
                            >
                              <BsChevronLeft className="text-gray-700" />
                            </button>
                            <button
                              onClick={() => handleRightClick(product.id)}
                              className="absolute right-0 transform -translate-y-1/2 top-1/2"
                            >
                              <BsChevronRight className="text-gray-700" />
                            </button>
                          </>
                        )}
                      </div>
                      <div className="flex items-center justify-start gap-1 px-1 text-xs font-semibold text-gray-900 bg-slate-50 max-w-16">
                        <CiStopwatch /> {product.time} {product.timeUnit}
                      </div>
                      <h3 className="mt-2 text-sm font-semibold text-left truncate">
                        {product.name}
                      </h3>
                      {product.size.length > 0 &&
                        product.size[0].id !== null && (
                          <div
                            className="flex items-center justify-between w-full h-10 px-3 border border-gray-300 rounded-md cursor-pointer"
                            onClick={() => openModal(product)}
                          >
                            <span className="text-black text-md">
                              {product.size[0].name}
                            </span>
                            <span className="text-gray-500">
                              <SlArrowDown />
                            </span>
                          </div>
                        )}
                      <div className="flex items-center justify-between">
                        <p className="pt-3 font-bold">₹{product.price[0]}</p>
                        {quantities[`${product.id}-${product.size[0].id}`] ? (
                          <div
                            className="flex items-center gap-2 px-2 py-1 text-white border rounded"
                            style={{ backgroundColor: themeColor }}
                          >
                            <button
                              onClick={() =>
                                handleQuantityChange(
                                  product.id,
                                  product.size[0].id,
                                  -1
                                )
                              }
                              className="px-1 py-1 text-sm font-semibold text-white rounded"
                              style={{ backgroundColor: themeColor }}
                            >
                              <FaMinus />
                            </button>
                            <input
                              type="number"
                              min="0"
                              value={
                                quantities[
                                `${product.id}-${product.size[0].id}`
                                ] ?? ""
                              }
                              onChange={async (e) => {
                                const rawValue = e.target.value;
                                const key = `${product.id}-${product.size[0].id}`;

                                if (rawValue === "") {
                                  setQuantities((prev) => ({
                                    ...prev,
                                    [key]: "",
                                  }));
                                  return;
                                }

                                const value = parseInt(rawValue);
                                if (!isNaN(value)) {
                                  setQuantities((prev) => ({
                                    ...prev,
                                    [key]: value,
                                  }));

                                  const cartItem = cartItems[key];
                                  const cartId = cartItem?.cart_id;
                                  const productId = cartItem?.product_id;

                                  if (value === 0) {
                                    setQuantities((prev) => {
                                      const updated = { ...prev };
                                      delete updated[key];
                                      return updated;
                                    });

                                    setCartItems((prev) => {
                                      const updated = { ...prev };
                                      delete updated[key];
                                      return updated;
                                    });

                                    if (productId) {
                                      try {
                                        await removeFromCart(productId);
                                      } catch (error) {
                                        console.error(
                                          "Error removing from cart:",
                                          error
                                        );
                                      }
                                    }
                                  } else if (cartId) {
                                    updateCartQuantity(cartId, value);
                                  }
                                }
                              }}
                              onBlur={() => {
                                const key = `${product.id}-${product.size[0].id}`;
                                if (quantities[key] === "") {
                                  setQuantities((prev) => ({
                                    ...prev,
                                    [key]: 1,
                                  }));
                                  const cartId = cartItems[key]?.cart_id;
                                  if (cartId) updateCartQuantity(cartId, 1);
                                }
                              }}
                              className="w-10 h-6 font-semibold text-center rounded"
                              style={{ backgroundColor: themeColor }}
                            />
                            <button
                              onClick={() =>
                                handleQuantityChange(
                                  product.id,
                                  product.size[0].id,
                                  1
                                )
                              }
                              className="px-1 py-1 text-sm font-semibold text-white rounded"
                              style={{ backgroundColor: themeColor }}
                            >
                              <FaPlus />
                            </button>
                          </div>
                        ) : (
                          <button
                            onClick={() => {
                              const key = `${product.id}-${product.size[0].id}`;
                              handleQuantityChange(product.id, product.size[0].id, 1);
                            }}
                            className={`border-1 py-2 px-4 rounded text-sm font-semibold bg-slate-50 ${vibratingButtons[`${product.id}-${product.size[0].id}`]
                                ? "vibrate"
                                : ""
                              }`}
                            style={{
                              color: themeColor,
                              border: `1px solid ${themeColor}`,
                            }}
                          >
                            ADD
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* 3 products per row */}
              {productsPerRow === 3 && (
                <div className="grid grid-cols-2 gap-2 md:grid-cols-3 md:p-2">
                  {products.map((product) => (
                    <div
                      key={product.name}
                      className="p-2 text-center bg-white border rounded-lg shadow-md md:p-3 h-72 md:h-96"
                    >
                      <div className="relative">
                        {(productImageAnimation === "Auto Scrolling" ||
                          productImageAnimation === "On Hover Scrolling" ||
                          productImageAnimation === "On Arrow Click") && (
                            <img
                              src={
                                product.images
                                  ? product.images[imageIndexes[product.id] || 0]
                                  : product.image
                              }
                              alt={product.name}
                              className="object-contain w-full transition-opacity duration-500 cursor-pointer max-h-52"
                              onMouseEnter={() => setHoveredProductId(product.id)}
                              onMouseLeave={() => setHoveredProductId(null)}
                              onClick={() =>
                                navigate(`/product-detail/${product.id}`)
                              }
                            />
                          )}
                        {productImageAnimation === "On Arrow Click" && (
                          <>
                            <button
                              onClick={() => handleLeftClick(product.id)}
                              className="absolute left-0 transform -translate-y-1/2 top-1/2"
                            >
                              <BsChevronLeft className="text-gray-700" />
                            </button>
                            <button
                              onClick={() => handleRightClick(product.id)}
                              className="absolute right-0 transform -translate-y-1/2 top-1/2"
                            >
                              <BsChevronRight className="text-gray-700" />
                            </button>
                          </>
                        )}
                      </div>
                      <div className="flex items-center justify-start gap-1 px-1 text-xs font-semibold text-gray-900 bg-slate-50 max-w-16">
                        <CiStopwatch /> {product.time} {product.timeUnit}
                      </div>
                      <h3 className="mt-2 text-sm font-semibold text-left truncate">
                        {product.name}
                      </h3>
                      {product.size.length > 0 &&
                        product.size[0].id !== null && (
                          <div
                            className="flex items-center justify-between w-full h-10 px-3 border border-gray-300 rounded-md cursor-pointer"
                            onClick={() => openModal(product)}
                          >
                            <span className="text-black text-md">
                              {product.size[0].name}
                            </span>
                            <span className="text-gray-500">
                              <SlArrowDown />
                            </span>
                          </div>
                        )}
                      <div className="flex items-center justify-between">
                        <p className="pt-3 font-bold">₹{product.price[0]}</p>
                        {quantities[`${product.id}-${product.size[0].id}`] ? (
                          <div
                            className="flex items-center gap-2 px-2 py-1 text-white border rounded"
                            style={{ backgroundColor: themeColor }}
                          >
                            <button
                              onClick={() =>
                                handleQuantityChange(
                                  product.id,
                                  product.size[0].id,
                                  -1
                                )
                              }
                              className="px-1 py-1 text-sm font-semibold text-white rounded"
                              style={{ backgroundColor: themeColor }}
                            >
                              <FaMinus />
                            </button>
                            <input
                              type="number"
                              min="0"
                              value={
                                quantities[
                                `${product.id}-${product.size[0].id}`
                                ] ?? ""
                              }
                              onChange={async (e) => {
                                const rawValue = e.target.value;
                                const key = `${product.id}-${product.size[0].id}`;

                                if (rawValue === "") {
                                  setQuantities((prev) => ({
                                    ...prev,
                                    [key]: "",
                                  }));
                                  return;
                                }

                                const value = parseInt(rawValue);
                                if (!isNaN(value)) {
                                  setQuantities((prev) => ({
                                    ...prev,
                                    [key]: value,
                                  }));

                                  const cartItem = cartItems[key];
                                  const cartId = cartItem?.cart_id;
                                  const productId = cartItem?.product_id;

                                  if (value === 0) {
                                    setQuantities((prev) => {
                                      const updated = { ...prev };
                                      delete updated[key];
                                      return updated;
                                    });

                                    setCartItems((prev) => {
                                      const updated = { ...prev };
                                      delete updated[key];
                                      return updated;
                                    });

                                    if (productId) {
                                      try {
                                        await removeFromCart(productId);
                                      } catch (error) {
                                        console.error(
                                          "Error removing from cart:",
                                          error
                                        );
                                      }
                                    }
                                  } else if (cartId) {
                                    updateCartQuantity(cartId, value);
                                  }
                                }
                              }}
                              onBlur={() => {
                                const key = `${product.id}-${product.size[0].id}`;
                                if (quantities[key] === "") {
                                  setQuantities((prev) => ({
                                    ...prev,
                                    [key]: 1,
                                  }));
                                  const cartId = cartItems[key]?.cart_id;
                                  if (cartId) updateCartQuantity(cartId, 1);
                                }
                              }}
                              className="w-10 h-6 font-semibold text-center bg-gray-300 rounded"
                            />
                            <button
                              onClick={() =>
                                handleQuantityChange(
                                  product.id,
                                  product.size[0].id,
                                  1
                                )
                              }
                              className="px-1 py-1 text-sm font-semibold text-white rounded"
                              style={{ backgroundColor: themeColor }}
                            >
                              <FaPlus />
                            </button>
                          </div>
                        ) : (
                          <button
                            onClick={() => {
                              const key = `${product.id}-${product.size[0].id}`;
                              handleQuantityChange(product.id, product.size[0].id, 1);
                            }}
                            className={`border-1 py-2 px-4 rounded text-sm font-semibold bg-slate-50 ${vibratingButtons[`${product.id}-${product.size[0].id}`]
                                ? "vibrate"
                                : ""
                              }`}
                            style={{
                              color: themeColor,
                              border: `1px solid ${themeColor}`,
                            }}
                          >
                            ADD
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Modal */}
          {isModalOpen && selectedProduct && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
              <div className="bg-slate-100 p-6 rounded-3xl shadow-lg w-[500px] max-h-[80vh] overflow-y-auto">
                <div className="flex items-center justify-between mb-4">
                  <h2 className="text-lg font-bold">{selectedProduct?.name}</h2>
                  <button
                    className="flex items-center justify-center p-2 text-white bg-gray-300 rounded-full hover:bg-gray-400"
                    onClick={() => setIsModalOpen(false)}
                  >
                    <IoMdClose />
                  </button>
                </div>
                <div className="max-h-[60vh] overflow-y-auto">
                  {selectedProduct?.size.map((size, index) => (
                    <div
                      key={index}
                      className="flex flex-row items-center justify-between gap-6 p-4 mb-2 bg-white border shadow-md rounded-xl"
                    >
                      <div className="flex items-center gap-4">
                        <div className="flex items-center justify-center w-24 h-24">
                          <img
                            src={selectedProduct?.images[0]}
                            alt={selectedProduct?.name}
                            className="object-contain w-full h-full"
                          />
                        </div>
                        <p className="pt-2 text-lg text-gray-600">
                          {size.name}
                        </p>
                        <p className="pt-2 text-lg font-semibold ml-14">
                          ₹{selectedProduct?.price[index]}
                        </p>
                      </div>
                      {quantities[`${selectedProduct.id}-${size.id}`] ? (
                        <div
                          className="flex items-center gap-2 px-2 py-1 text-white border rounded"
                          style={{ backgroundColor: themeColor }}
                        >
                          <button
                            onClick={() =>
                              handleQuantityChangeModal(size.id, -1)
                            }
                            className="px-1 py-1 font-bold text-white"
                            style={{ backgroundColor: themeColor }}
                          >
                            <FaMinus />
                          </button>
                          <input
                            type="number"
                            min="0"
                            value={
                              quantities[`${selectedProduct.id}-${size.id}`] ??
                              ""
                            }
                            onChange={async (e) => {
                              const rawValue = e.target.value;
                              const key = `${selectedProduct.id}-${size.id}`;

                              if (rawValue === "") {
                                setQuantities((prev) => ({
                                  ...prev,
                                  [key]: "",
                                }));
                                return;
                              }

                              const value = parseInt(rawValue);
                              if (!isNaN(value)) {
                                setQuantities((prev) => ({
                                  ...prev,
                                  [key]: value,
                                }));

                                const cartItem = cartItems[key];
                                const cartId = cartItem?.cart_id;
                                const productId = cartItem?.product_id;

                                if (value === 0) {
                                  setQuantities((prev) => {
                                    const updated = { ...prev };
                                    delete updated[key];
                                    return updated;
                                  });

                                  setCartItems((prev) => {
                                    const updated = { ...prev };
                                    delete updated[key];
                                    return updated;
                                  });

                                  if (productId) {
                                    try {
                                      await removeFromCart(productId);
                                    } catch (error) {
                                      console.error(
                                        "Error removing from cart:",
                                        error
                                      );
                                    }
                                  }
                                } else if (cartId) {
                                  updateCartQuantity(cartId, value);
                                }
                              }
                            }}
                            onBlur={() => {
                              const key = `${selectedProduct.id}-${size.id}`;
                              if (quantities[key] === "") {
                                setQuantities((prev) => ({
                                  ...prev,
                                  [key]: 1,
                                }));
                                const cartId = cartItems[key]?.cart_id;
                                if (cartId) updateCartQuantity(cartId, 1);
                              }
                            }}
                            className="w-10 h-6 font-semibold text-center rounded"
                            style={{ backgroundColor: themeColor }}
                          />
                          <button
                            onClick={() =>
                              handleQuantityChangeModal(size.id, 1)
                            }
                            className="px-1 py-1 font-bold text-white"
                            style={{ backgroundColor: themeColor }}
                          >
                            <FaPlus />
                          </button>
                        </div>
                      ) : (
                        <button
                          onClick={() => {
                            const key = `${selectedProduct.id}-${size.id}`;
                            handleQuantityChangeModal(size.id, 1);
                          }}
                          className={`py-2 px-4 rounded text-sm font-semibold bg-slate-50 ${vibratingButtons[`${selectedProduct.id}-${size.id}`] ? "vibrate" : ""
                            }`}
                          style={{
                            color: themeColor,
                            border: `1px solid ${themeColor}`,
                          }}
                        >
                          ADD
                        </button>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Login Modal */}
          {isLoginModalOpen && (
            <Login isOpen={isLoginModalOpen} onClose={closeLoginModal} />
          )}
        </div>
      </div>
    </div>
  );
}
// import { addToWishlist, removeFromWishlist, getWishlistProducts } from "../../utils/wishlistUtils";
// const syncWishlist = async (productList) => {
//   const token = sessionStorage.getItem("accessToken");
//   if (!token || !Array.isArray(productList)) return;

//   try {
//     const wishlist = await getWishlistProducts();

//     const wishlistSet = new Set(
//       wishlist.map((w) => String(w.product_auto_id))
//     );

//     const updatedFavorites = {};
//     productList.forEach((product) => {
//       updatedFavorites[product.id] = wishlistSet.has(
//         String(product.product_auto_id)
//       );
//     });

//     setFavorites(updatedFavorites);
//   } catch (error) {
//     console.error("Wishlist sync failed:", error);
//   }
// };

//   useEffect(() => {
//   if (products.length > 0) {
//     syncWishlist(products);
//   }
// }, [products]);